/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import classes from "./quotes.module.css";
import QuoteTable from "./quoteTable";
import Input from "../../../component/inputpm";
import Loader from "../../../component/loader";
import ResendDialog from "../order/resendDialog";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import Select from "@mui/material/Select";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import { IconButton } from "@mui/material";
import {
  SearchIcon,
  ClearIcon,
  RefreshIcon,
  DetailView,
  ListView,
  UsersIcon,
} from "../../../component/icons/icons";
import Button from "../../../component/button";
import { Grid, InputLabel, FormControl } from "@mui/material";
import Card from "@mui/material/Card";
import ManageCustomersHierarchy from "../manageCustomers/manageCustomersHierarchy";
import { ButtonGroup } from "@mui/material";
import dateFormat from "dateformat";
import { withNavigation } from '../../../helper/withNavigation';

// Manage order page class
class Quotes extends Component {
  // Declare property values that belongs to the component
  state = {
    quoteId: "",
    customerName: "",
    customerBAN: "",
    sortBy: "createdTxStamp",
    sortOrder: "DESC",
    controls: true,
    tenant: "",
    // statusList: [],
    quotes: [],
    rowsPerPage: 10,
    page: 1,
    startRecord: 1,
    totalQuoteCount: 0,
    loading: true,
    isMailDialog: false,
    bread: [{ title: this.props.t("QUOTES"), url: "/quotes" }],
    showLoading: true,
    statusList: [],
    quoteStatus: "All Quotes",
    type: "All Quotes",
    typeList: [
      // {
      //     name: '',
      //     value: ''
      // },
      {
        name: "ALL_QUOTES",
        value: "All Quotes",
      },
      {
        name: "NEW_ACTIVATION",
        value: "NewActivation",
      },
      {
        name: "CHANGE_SUBSCRIPTION",
        value: "ChangeSubscription",
      },
      {
        name: "SHIFT_SUBSCRIPTION",
        value: "ShiftSubscription",
      },
      {
        name: "CANCEL_SUBSCRIPTION",
        value: "CancelSubscription",
      },
    ],

    isMobile: false,
    showCustomerList: false,
    showAllOrders: undefined,
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    this.updateIsMobile();
    if (this.props.providerType === "SALES_CHNL_PROVIDER") {
      const quoteView = localStorage.getItem("quoteView");
      this.setState({
        showAllOrders: quoteView === "list" ? true : false,
      });
    } else {
      this.setState({
        showAllOrders: true,
      });
    }
    BusApiCall(
      "POST",
      `${constants.busInternalUrl}/passthru/GET_QUOTE_STATUSES/endpoint`,
      {},
    )
      .then((res) => {
        let list = res.data;
        // let all = {
        //     name: 'All Orders',
        //     value: 'All Orders'
        // }
        // list.unshift(all)
        this.setState({
          statusList: res.data,
        });
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
      });
    this.callGetQuotes();
  }

  updateIsMobile = () => {
    const isMobile = window.matchMedia("(max-width: 960px)").matches;
    this.setState({ isMobile });
  };

  toggleShowCustomerList = () => {
    this.setState((prevState) => ({
      showCustomerList: !prevState.showCustomerList,
    }));
  };

  callGetQuotes = () => {
    // this.getQuotes();
    let initialFilters = JSON.parse(localStorage.getItem("quoteFilters"));
    if (initialFilters) {
      this.setState(
        {
          rowsPerPage: initialFilters.rowsPerPage,
          startRecord: initialFilters.startRecord,
          page: initialFilters.page,
          sortBy: initialFilters.sortBy,
          sortOrder: initialFilters.sortOrder,
          quoteId: initialFilters.quoteId ? initialFilters.quoteId : "",
          quoteStatus: initialFilters.quoteStatus
            ? initialFilters.quoteStatus
            : "",
          customerBAN: initialFilters.customerBAN
            ? initialFilters.customerBAN
            : "",
          customerName: initialFilters.customerName
            ? initialFilters.customerName
            : "",
          type: initialFilters.type ? initialFilters.type : "",
          tenant: initialFilters.tenant ? initialFilters.tenant : "",
        },
        () => {
          this.getQuotes();
        },
      );
    } else {
      this.getQuotes();
    }
  };

  // Fetch orders list
  getQuotes = () => {
    this.setState({
      loading: true,
      showLoading: true,
    });
    let pageOptions = {
      batchSize: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
    };

    // START: Store order filters data
    let quoteFilters = {
      rowsPerPage: this.state.rowsPerPage,
      startRecord: this.state.startRecord,
      page: this.state.page,
      sortBy: this.state.sortBy,
      sortOrder: this.state.sortOrder,

      quoteId: this.state.quoteId,
      quoteStatus:
        this.state.quoteStatus === "All Quotes" ? "" : this.state.quoteStatus,
      customerBAN: this.state.customerBAN,
      customerName: this.state.customerName,
      type: this.state.type === "All Quotes" ? "" : this.state.type,
      tenant: this.state.tenant,
    };
    localStorage.setItem("quoteFilters", JSON.stringify(quoteFilters));
    // END: Store order filters data
    BusApiCall(
      "GET",
      `${constants.busV44UrlPublic}/quotes?sortBy=${this.state.sortBy}&sortOrder=${this.state.sortOrder}&id=${this.state.quoteId}&state=${encodeURIComponent(this.state.quoteStatus && this.state.quoteStatus === "All Quotes" ? "" : this.state.quoteStatus)}&customerName=${this.state.customerName}&customerBan=${this.state.customerBAN}&type=${encodeURIComponent(this.state.type && this.state.type === "All Quotes" ? "" : this.state.type)}`,
      {},
      pageOptions,
    )
      .then((res) => {
        let data = res.data;
        this.setState({
          quotes: data,
          totalQuoteCount: +res.headers["x-total-count"],
          loading: false,
          showLoading: false,
        });
        // if (data.length > 0) {
        //     for (let item of data) {
        //         item.accountName = item.customer.companyName;
        //         item.ban = item.customer.ban;
        //         // Check whether the order is auto-activated or not
        //         for (let userItem of item.userData) {
        //             if (userItem.name === 'autoActivatable') {
        //                 item.autoActivatable = userItem.value
        //             }
        //         }
        //     }
        //     this.setState({
        //         orders: data,
        //         totalQuoteCount: +res.headers['x-total-count'],
        //         loading: false,
        //         showLoading: false
        //     })
        // } else {
        //     this.setState({
        //         orders: [],
        //         totalQuoteCount: 0,
        //         loading: false,
        //         showLoading: false
        //     })
        // }
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage(
            this.props.t("DEFAULT_ERROR_MESSAGE"),
            false,
          );
        }
        this.setState({ loading: false });
      });
  };

  // Update state data on input change
  onChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  // Open resend confirmation email modal
  openResendDialog = (orderId) => {
    this.setState({
      isMailDialog: true,
      actionOrderId: orderId,
    });
  };

  // Change page
  handleChangePage = (event, newPage) => {
    this.setState(
      {
        page: newPage,
        startRecord: this.state.rowsPerPage * (newPage - 1) + 1,
      },
      () => {
        this.getQuotes();
      },
    );
  };

  // Change rows per page
  handleChangeRowsPerPage = (event) => {
    this.setState(
      {
        page: 1,
        rowsPerPage: event.target.value,
        startRecord: 1,
      },
      () => {
        this.getQuotes();
      },
    );
  };

  // Close confirmation email dialog
  closeMailDialog = () => {
    this.setState({
      isMailDialog: false,
      actionOrderId: "",
    });
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getQuotes();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getQuotes();
        },
      );
    }
  };

  // Change table sorting
  updateSorting = (by) => {
    if (by === this.state.sortBy) {
      this.setState(
        {
          sortOrder: this.state.sortOrder === "DESC" ? "ASC" : "DESC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getQuotes();
        },
      );
    } else {
      this.setState(
        {
          sortBy: by,
          sortOrder: "ASC",
          page: 1,
          startRecord: 1,
        },
        () => {
          this.getQuotes();
        },
      );
    }
  };

  // Search/Filter orders
  filterOrderTable = () => {
    this.setState(
      {
        page: 1,
        startRecord: 1,
        quoteId: this.state.quoteId,
        customerName: this.state.customerName,
        customerBAN: this.state.customerBAN,
        quoteStatus: this.state.quoteStatus,
        tenant: this.state.tenant,
      },
      () => {
        this.getQuotes();
      },
    );
  };

  // Clear all search filters
  clearOrderTableSearch = () => {
    this.setState(
      {
        quoteId: "",
        customerName: "",
        customerBAN: "",
        quoteStatus: "",
        tenant: "",
        page: 1,
        startRecord: 1,
      },
      () => {
        this.getQuotes();
      },
    );
  };

  // Clear all search filters and refeesh data
  refreshOrderTableSearch = () => {
    this.setState(
      {
        quoteId: "",
        customerName: "",
        customerBAN: "",
        quoteStatus: "",
        tenant: "",
        page: 1,
        startRecord: 1,
        sortBy: "createdTxStamp",
        sortOrder: "DESC",
      },
      () => {
        this.getQuotes();
      },
    );
  };

  // Search orders on press enter key
  onSearchKeyDown = (e) => {
    if (e.key === "Enter") {
      this.filterOrderTable();
    }
  };


  toggleShowAllOrders = (view) => {
    if (view === "list") {
      this.setState(
        {
          showAllOrders: true,
        },
        () => {
          this.callGetQuotes();
        },
      );
    } else if (view === "detail") {
      this.setState({
        showAllOrders: false,
      });
    } else {
      this.setState((prevState) => ({
        showAllOrders: !prevState.showAllOrders,
      }));
    }
    localStorage.setItem("quoteView", view);
  };

  // Render order view
  render() {
    const { t } = this.props;
    const { isMobile, showCustomerList } = this.state;
    return (
      <div className={"newContentWrapper"}>
        <div className={"breadcrumbWrapper"}>
          <div className={"breadcrumbContent"}>
            <Grid container spacing={1}>
              <Grid
                item
                size={{
                  xs: 6,
                }}
              >
                <Breadcrumb list={this.state.bread} />
              </Grid>
              <Grid
                item
                style={{ textAlign: "right" }}
                size={{
                  xs: 6,
                }}
              >
                {
                  /*Pratyush - Check if the user has the new Order Permission*/
                  this.props.menuPaths.includes("/newOrder") &&
                  this.props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                    <Button
                      onClick={() => this.props.router.navigate("/newOrder")}
                    >
                      <span
                        style={{
                          marginRight: ".25rem",
                          verticalAlign: "middle",
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 12 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6 2C6.27614 2 6.5 2.22386 6.5 2.5V5.5H9.5C9.77614 5.5 10 5.72386 10 6C10 6.27614 9.77614 6.5 9.5 6.5H6.5V9.5C6.5 9.77614 6.27614 10 6 10C5.72386 10 5.5 9.77614 5.5 9.5V6.5H2.5C2.22386 6.5 2 6.27614 2 6C2 5.72386 2.22386 5.5 2.5 5.5H5.5V2.5C5.5 2.22386 5.72386 2 6 2Z"
                            fill="currentColor"
                          />
                        </svg>
                      </span>
                      {this.props.t("NEW_QUOTE")}
                    </Button>
                  )
                }
              </Grid>
            </Grid>
          </div>
        </div>
        <main style={{ position: "relative", paddingTop: "1rem" }}>
          {this.props.providerType === "SALES_CHNL_PROVIDER" && (
            <Grid container spacing={1}>
              {/* <Grid item xs={12} md={6} justifyContent="flex-end">
                                <FormControlLabel
											control={
												<Switch
													color="primary"
													checked={this.state.showAllOrders}
													name="showAllOrders"
													onChange={(e) => this.toggleShowAllOrders()}
												/>
											}
											label={this.props.t("SHOW_ALL_QUOTES")}
										/>
                            </Grid> */}
              <Grid
                item
                style={{
                  display: "flex",
                  gap: "1rem",
                  justifyContent: "flex-end",
                  marginBottom: "1rem",
                }}
                size={{
                  xs: 12,
                  md: 12,
                }}
              >
                {isMobile && (
                  <Button
                    className="buttonSecondary"
                    onClick={this.toggleShowCustomerList}
                  >
                    <span
                      style={{ marginRight: ".25rem", verticalAlign: "middle" }}
                    >
                      <UsersIcon />
                    </span>
                    {t("SHOW_CUSTOMER_LIST")}
                  </Button>
                )}
                <ButtonGroup variant="outlined">
                  {/* DETAIL VIEW button */}
                  <span
                    className={`buttonGroup ${!this.state.showAllOrders ? "selected" : ""}`}
                    onClick={(e) => this.toggleShowAllOrders("detail")}
                    style={{
                      backgroundColor: !this.state.showAllOrders
                        ? this.props.tenantData.color
                        : "inherit",
                      color: !this.state.showAllOrders ? "white" : "inherit",
                    }}
                  >
                    <span style={{ marginRight: ".4rem" }}>
                      {this.props.t("DETAIL_VIEW")}
                    </span>
                    <DetailView />
                  </span>
                  {/* LIST VIEW button */}
                  <span
                    className={`buttonGroup ${this.state.showAllOrders ? "selected" : ""}`}
                    onClick={(e) => this.toggleShowAllOrders("list")}
                    style={{
                      backgroundColor: this.state.showAllOrders
                        ? this.props.tenantData.color
                        : "inherit",
                      color: this.state.showAllOrders ? "white" : "inherit",
                    }}
                  >
                    <span>{this.props.t("LIST_VIEW")}</span>
                    <ListView />
                  </span>
                </ButtonGroup>
              </Grid>
            </Grid>
          )}
          {!this.state.showAllOrders ? (
            <>
              <ManageCustomersHierarchy
                screen="quotes"
                userId={this.state.userId}
                onRef={(ref) => (this.hierarchyRef = ref)}
                isMobile={isMobile}
                showCustomerList={showCustomerList}
                toggleShowCustomerList={this.toggleShowCustomerList}
                openResendDialog={this.openResendDialog}
                controls={this.state.controls}
                loggedInUserType={this.props.loggedInUserType}
                providerType={this.props.providerType}
                showLoading={this.state.showLoading}
                // orderStatus={this.state.orderStatus}
                statusList={this.state.statusList}
                typeList={this.state.typeList}
                // onChange={this.onChange}
                // onSearchKeyDown={this.onSearchKeyDown}
                // tenant={this.state.tenant}
                // tenantList={this.state.tenantList}
                // filterOrderTable={this.filterOrderTable}
                // clearOrderTableSearch={this.clearOrderTableSearch}
                // refreshOrderTableSearch={this.refreshOrderTableSearch}

                setErrorMessage={this.props.setErrorMessage}
              />
            </>
          ) : (
            <>
              {/* <Paper className="tablePaper"> */}
              {/* Search filters start */}
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{ marginBottom: ".5rem" }}>
                  <div className={classes.searchOuterDiv}>
                    <div className={classes.searchInputDiv}>
                      <Input
                        size={"small"}
                        variant={"outlined"}
                        placeholder={t("QUOTE_ID")}
                        value={this.state.quoteId}
                        name={"quoteId"}
                        onChange={(e) => {
                          this.onChange(e);
                        }}
                        divClass={classes.inputClass}
                        onKeyDown={(e) => {
                          this.onSearchKeyDown(e);
                        }}
                      />
                    </div>
                    {(this.props.loggedInUserType != "ECOMMERCE_CUSTOMER" ||
                      this.props.loggedInUserType != "ECOMMERCE_ADMIN") && (
                        <>
                          <div className={classes.searchInputDiv}>
                            <Input
                              size={"small"}
                              variant={"outlined"}
                              placeholder={t("CUSTOMER_NAME")}
                              value={this.state.customerName}
                              name={"customerName"}
                              onChange={(e) => {
                                this.onChange(e);
                              }}
                              divClass={classes.inputClass}
                              onKeyDown={(e) => {
                                this.onSearchKeyDown(e);
                              }}
                            />
                          </div>
                          <div className={classes.searchInputDiv}>
                            <Input
                              size={"small"}
                              variant={"outlined"}
                              placeholder={t("CUSTOMER_BAN")}
                              value={this.state.customerBAN}
                              name={"customerBAN"}
                              onChange={(e) => {
                                this.onChange(e);
                              }}
                              divClass={classes.inputClass}
                              onKeyDown={(e) => {
                                this.onSearchKeyDown(e);
                              }}
                            />
                          </div>
                        </>
                      )}
                    <div className={classes.searchInputDiv}>
                      <FormControl
                        variant="outlined"
                        size={"small"}
                      >
                        <InputLabel id="status-label">
                          {t("STATUS")}
                        </InputLabel>
                        <Select
                          native
                          label={t("STATUS")}
                          labelId="status-label"
                          value={this.state.quoteStatus}
                          onChange={(e) => {
                            this.onChange(e);
                          }}
                          inputProps={{
                            name: "quoteStatus",
                            id: "outlined-native-quoteStatus",
                          }}
                          onKeyDown={(e) => {
                            this.onSearchKeyDown(e);
                          }}
                          style={{ width: "186px" }}
                        >
                          <option value={"All Quotes"}>
                            {t("ALL_QUOTES")}
                          </option>
                          {this.state.statusList.map((a) => (
                            <option key={a.name} value={a.name}>
                              {a.value}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    <div className={classes.searchInputDiv}>
                      <FormControl
                        variant="outlined"
                        size={"small"}
                      >
                        <InputLabel id="type-label">
                          {t("TYPE")}
                        </InputLabel>
                        <Select
                          native
                          label={t("TYPE")}
                          labelId="type-label"
                          value={this.state.type}
                          onChange={(e) => {
                            this.onChange(e);
                          }}
                          inputProps={{
                            name: "type",
                            id: "outlined-native-type",
                          }}
                          onKeyDown={(e) => {
                            this.onSearchKeyDown(e);
                          }}
                          style={{ width: "186px" }}
                        >
                          {this.state.typeList.map((a) => (
                            <option key={a.value} value={a.value}>
                              {t(a.name)}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                    {/* <div className={classes.searchOrderLabelOuter}>
                                <div className={classes.searchOrderLabelInner}> */}
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <Tooltip title={t("SEARCH")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.filterOrderTable}
                        >
                          <SearchIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("CLEAR")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.clearOrderTableSearch}
                        >
                          <ClearIcon />
                        </IconButton>
                      </Tooltip>{" "}
                      &nbsp;
                      <Tooltip title={t("REFRESH")}>
                        <IconButton
                          className="iconButtonSecondary"
                          onClick={this.refreshOrderTableSearch}
                        >
                          <RefreshIcon />
                        </IconButton>
                      </Tooltip>
                    </div>
                    {/* </div>
                            </div> */}
                    {/* <div className='cl'></div> */}
                  </div>
                </div>
                {/* Search filters end */}
                <Card variant="outlined" style={{ borderRadius: "8px" }}>
                  {/* Order table component */}
                  <QuoteTable
                    customerName={this.state.customerName}
                    customerBAN={this.state.customerBAN}
                    quotes={this.state.quotes}
                    openResendDialog={this.openResendDialog}
                    rowsPerPage={this.state.rowsPerPage}
                    totalQuoteCount={this.state.totalQuoteCount}
                    page={this.state.page}
                    sortBy={this.state.sortBy}
                    sortOrder={this.state.sortOrder}
                    updateSorting={this.updateSorting}
                    handleChangePage={this.handleChangePage}
                    handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                    controls={this.state.controls}
                    loggedInUserType={this.props.loggedInUserType}
                    tenantId={this.state.tenant}
                    providerType={this.props.providerType}
                    showLoading={this.state.showLoading}
                  />
                </Card>
              </div>
              {/* </Paper> */}
            </>
          )}
          {/* Resend confirmation dialog component */}
          <ResendDialog
            isOpen={this.state.isMailDialog}
            close={this.closeMailDialog}
            orderId={this.state.actionOrderId}
          />
          <Loader loading={this.state.loading} />
        </main>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loggedInUserId: state.auth.loggedInUserId,
    loggedInUserType: state.auth.userLoginType,
    providerType: state.auth.providerType,
    menuPaths: state.auth.menuPaths,
    tenantData: state.auth.tenantData,
    showMyCustomers: state.auth.showMyCustomers,
    userPerms: state.auth.userPerms,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(Quotes)));
